import React from 'react';
import './headPartner.css';
import HeadPartnersLogo from '../../img/HeadPartners/HeadPartnersLogo.png';
import { t } from "i18next";


export default class HeadPartners extends React.Component {
    render() {
        return (
            <div className='headPartners-wrap'>
                <div className='container'>
                    <h3 className='headPartners-title'>{t("headPartner.title")}</h3>
                    <img className='headPartners-logo' src={HeadPartnersLogo} alt="HeadPartnersLogo" />
                    <p className='headPartners-description'>{t("headPartner.desc1")}</p>
                    <p className='headPartners-description'>{t("headPartner.desc2")}<br/>{t("headPartner.desc3")}</p>
                </div>
            </div>
        )
    }
}